import { obterImagem } from '@/util/imagem'

const faturaMixin = {
  data: () => {
    return {
      bandeiras: [
        { nome: 'visa.svg', codigos: [4], regex: /^4[0-9]{12}(?:[0-9]{3})/ },
        { nome: 'mastercard.svg', codigos: [5], regex: /^5[1-5][0-9]{14}/ },
        { nome: 'american-express.svg', codigos: [34, 37], regex: /^3[47][0-9]{13}/ },
        { nome: 'hipercard.svg', codigos: [4011, 4313], regex: /^(606282\d{10}(\d{3})?)|(3841\d{15})/ },
        { nome: 'elo.svg', codigos: [38], regex: /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})/ }
      ]
    }
  },
  methods: {
    obterDescricaoStatusFatura (codigoStatus) {
      switch (codigoStatus) {
        case 1:
          return 'Pago'
        case 2:
          return 'Aguardando confirmação'
        case 3:
          return 'Em aberto'
        case 4:
          return 'Atrasado'
      }
      return null
    },

    obterBandeiraCartaoPorFiltro (valor, filtro) {
      return this.bandeiras.find(filtro.bind(null, valor))
    },
    obterIconeBandeira (nome) {
      if (!nome) {
        return
      }
      const iconeBandeira = `bandeiras/${nome}`
      return obterImagem(iconeBandeira)
    }
  }
}

export { faturaMixin }
